{
  "_meta": {
    "_comment": "Phase 14.1 Wave 9 Task 46 — merchant pricing namespace (LiveCostCalculator breakdown, rush toggle, service picker, packing-group summary, price error copy). Money rendered via Money/formatUsd, values from API. vg-binding: P14.1.D-04 / P14.1.D-19 / INTERFACE-STANDARDS:error-shape",
    "locale": "en"
  },
  "breakdown": {
    "title": "Cost breakdown",
    "subtotal": "Subtotal",
    "productTotal": "Products",
    "embroideryFee": "Embroidery fee",
    "rushFee": "Rush fee",
    "shippingFee": "Shipping",
    "tax": "Tax",
    "tariff": "Tariff",
    "discount": "Discount",
    "total": "Total",
    "estimatedTotal": "Estimated total",
    "perItem": "Per item",
    "empty": "Add items to see the cost breakdown."
  },
  "rush": {
    "toggleLabel": "Rush production",
    "toggleHint": "Prioritize this order for faster production. A rush fee applies per item.",
    "badge": "Rush",
    "unavailable": "Rush isn't available for this destination."
  },
  "service": {
    "pickerLabel": "Shipping method",
    "pickerPlaceholder": "Select a shipping method",
    "estimatedDelivery": "Estimated delivery {{window}}"
  },
  "packingGroups": {
    "title": "Shipping groups",
    "groupLabel": "Group {{index}}",
    "itemsCount": "{{count}} item(s)",
    "shippingPerGroup": "Shipping for this group",
    "consolidatedHint": "Items shipping together are charged one shipping fee per group."
  },
  "errors": {
    "productPriceMissing": "Pricing isn't available for one or more items yet.",
    "shippingFeeMissing": "Shipping isn't configured for the selected service and destination.",
    "priceDrift": "The price has changed since your quote. Review the updated total before confirming.",
    "embPaymentNotPending": "This embroidery fee is no longer awaiting payment. Refresh and try again.",
    "embFeeQuoteMismatch": "The embroidery fee has changed. Review the updated fee before accepting.",
    "walletInsufficient": "Your wallet balance is insufficient. Top up and try again.",
    "rushFeeZoneMissing": "Rush production isn't available for one or more items to this destination.",
    "generic": "We couldn't calculate the price. Please try again or contact support."
  },
  "status": {
    "calculating": "Calculating…",
    "recalculated": "Price updated"
  }
}
